import Header from '@/components/Header/Header';
import SimpleHeader from '@/pages/components/Headers/SimpleHeader';
import { Box } from '@mui/material';
import NELiveDetection from '@yidun/livedetect-sdk-h5';
import '@yidun/livedetect-sdk-h5/dist/es/NELiveDetection.css';
import { useEffect, useRef } from 'react';

const LiveDetect = () => {
  const neLiveDetection = useRef();

  useEffect(() => {
    _initNELiveDetection();

    return () => {
      if (neLiveDetection.current) {
        if (neLiveDetection.current?.stop) {
          neLiveDetection.current?.stop();
        }
      }
    }
  }, []);

  const _initNELiveDetection = () => {
    neLiveDetection.current = new NELiveDetection({
      businessKey: '7a216dafebf84d00adf154c9010f4054',
      container: '#NELiveDetection',
      diameter: 220,
      lang: 'en-US',
      onMount: (instance) => {
        console.log('live detect mount complete');
      },
      // 等价于 instance.on('ready', () => {})
      // onReady: (instance) => {
      //   console.log('live detect ready');
      // },
    });
  
    // 实例化后必须调用 mount 方法
    neLiveDetection.current && neLiveDetection.current.mount();
  
    // 调用 start 方法开始活体检测流程
    neLiveDetection.current.on('ready', () => {
      neLiveDetection.current.start();
    });
  
    // 流程走完并检验完成
    neLiveDetection.current.on('verify', (token) => {
      console.log('token:', token);
      // 在校验成功拿到 token

      // token
    });
  
    // 发生错误
    neLiveDetection.current.on('error', (err) => {
      console.log('err:', err);
      switch (err.name) {
        case '10000': // 校验未通过错误码
          // 如果校验未成功，会返回 err 对象，做后续处理
          break;
        // 其他错误码
        default:
          break;
      }
    });
  }

  return <Box sx={{ width: '100%' }}>
    <SimpleHeader title={''} />
    <div id="NELiveDetection"></div>
  </Box>
}

export default LiveDetect